<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->

<div>
  <h2 mat-dialog-title>License Agreement</h2>
  <mat-dialog-content>
    <div>
      Please click to view the license agreement for
      <!-- <a class="open-dialog" target="_blank" [href]="data.license_agreement.url">{{ data.name }}</a> -->
      <a class="open-dialog" (click)="openLicense()">{{ data.name }}</a>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button *ngIf="!data.license_agreement.accepted" mat-raised-button mat-dialog-close>Cancel</button>
    <button *ngIf="!data.license_agreement.accepted" mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>
      Accept
    </button>
    <button *ngIf="data.license_agreement.accepted" mat-raised-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
